/**
 * Convierte una URL del proxy de descarga a absoluta.
 *
 * El backend devuelve `/files/download?token=...` (relativa). Si se pasa
 * directo a `window.open` o `window.location`, el navegador la interpreta
 * como ruta del front (HashRouter) y cae en el Redirect a /dashboard.
 *
 * También corrige bases mal configuradas que incluyen `/graphql`:
 * `http://host/graphql/files/download` → `http://host/files/download`.
 */

/** Base HTTP del API para rutas como `/files/download` (sin sufijo `/graphql`). */
export function apiStaticBaseFromReactEnv() {
  const raw =
    (typeof process !== "undefined" && process.env && process.env.REACT_APP_API_URL) || "";
  const trimmed = String(raw).trim();
  if (trimmed) {
    try {
      const u = new URL(trimmed);
      let path = u.pathname.replace(/\/$/, "");
      if (/\/graphql$/i.test(path)) {
        path = path.replace(/\/graphql$/i, "");
      }
      path = path.replace(/\/$/, "");
      return path ? `${u.origin}${path}` : u.origin;
    } catch {
      const stripped = trimmed.replace(/\/$/, "").replace(/\/graphql\/?$/i, "");
      return stripped || "http://localhost:3000";
    }
  }

  // Sin REACT_APP_API_URL: el front suele ir en :8001 y el API en :3000 (no usar window.location.origin).
  if (typeof window !== "undefined") {
    const { hostname, protocol, port } = window.location;
    if ((hostname === "localhost" || hostname === "127.0.0.1") && port === "8001") {
      return `${protocol}//${hostname}:3000`;
    }
  }
  return "http://localhost:3000";
}

/** Si la URL absoluta incluye por error `/graphql` antes de `/files/download`, lo quita. */
function stripGraphqlBeforeFilesPath(url) {
  return url.replace(/\/graphql(?=\/files\/download)/i, "");
}

/** Reconstruye cualquier URL de descarga proxy usando la base del API (REACT_APP_API_URL → :3000). */
function rebaseFilesDownloadUrl(url) {
  const apiBase = apiStaticBaseFromReactEnv();
  const pathMatch = String(url).match(/\/files\/download\?[^\s#]*/i);
  if (!pathMatch) return url;
  return `${apiBase}${pathMatch[0]}`;
}

export const toAbsoluteDownloadUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  if (/^https?:\/\//i.test(url)) {
    if (/\/files\/download\?/i.test(url)) {
      return rebaseFilesDownloadUrl(stripGraphqlBeforeFilesPath(url));
    }
    return stripGraphqlBeforeFilesPath(url);
  }
  const base = apiStaticBaseFromReactEnv();
  return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
};

export default toAbsoluteDownloadUrl;
